import { render, staticRenderFns } from "./ModalIconBank.vue?vue&type=template&id=8155bcfa&"
import script from "./ModalIconBank.vue?vue&type=script&lang=js&"
export * from "./ModalIconBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports